import { getToken } from '@wisory-international-ab/login-frontend';
import ReactGA from 'react-ga4';
import { getAppConfigurations } from '../utils';
import { getGAEventObjectStorage } from '../utils/localstorage';

type GA_EVENT =
  | 'Navigation_Click_MyDashboard'
  | 'Navigation_Click_MySession'
  | 'Navigation_Click_AllAdvisors'
  | 'Navigation_Click_WisoryLearning'
  | 'Navigation_Click_Company'
  | 'Navigation_Click_MyFeedback'
  | 'User_Change_Role'
  | 'User_Click_LogoutButton'
  | 'User_Logout_Confirm_Success'
  | 'User_Logout_Confirm_Cancel'
  | 'User_ChangeLanguage_Swedish'
  | 'User_ChangeLanguage_English'
  | 'Advisor_Create_AvailableSlot_Success'
  | 'Advisor_Delete_AvailableSlot_Success'
  | 'User_View_SessionDetails_CancelledSession'
  | 'User_View_SessionDetails_PendingConfirmation'
  | 'User_View_BookingRequest'
  | 'User_View_ReschedulingRequest'
  | 'User_Click_RejectAndPurpose'
  | 'User_Click_SendProposal'
  | 'User_Click_TermsForRebooking';

const { gaMeasurementId, environment } = getAppConfigurations();

export function setupTrackings() {
  if (environment === 'local') {
    return;
  }
  console.log('Google analytics setup');
  ReactGA.initialize(gaMeasurementId);
}

export function trackPage(path: string) {
  if (environment === 'local') {
    return;
  }
  const userSession = getToken();
  const customProperties = getGAEventObjectStorage(userSession?.userId) || {};
  // Send pageview with a custom path
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    ...customProperties,
  });
}

export function trackEvent(
  action: GA_EVENT,
  category: 'NAVIGATION' | 'CALENDAR' | 'BOOKING DETAIL'
) {
  if (environment === 'local') {
    return;
  }
  const userSession = getToken();
  const customProperties = getGAEventObjectStorage(userSession?.userId) || {};
  // Send a custom event
  ReactGA.event(action, {
    category,
    action,
    label: category,
    ...customProperties,
  });
}
